"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ClipboardIcon = void 0;

var _react = _interopRequireDefault(require("react"));

var _theming = require("@storybook/theming");

var _styles = require("../shared/styles");

var _Icon = require("../Icon");

var _Clipboard = require("./Clipboard");

var StyledClipboard = ( /*#__PURE__*/0, _theming.styled)(_Clipboard.Clipboard, process.env.NODE_ENV === "production" ? {
  target: "ewp3f4r1"
} : {
  target: "ewp3f4r1",
  label: "StyledClipboard"
})("line-height:10px;padding:10px;color:", _styles.color.mediumdark, ";&:hover{color:", _styles.color.darker, ";}");
var StyledIcon = ( /*#__PURE__*/0, _theming.styled)(_Icon.Icon, process.env.NODE_ENV === "production" ? {
  target: "ewp3f4r0"
} : {
  target: "ewp3f4r0",
  label: "StyledIcon"
})("width:12px;height:12px;vertical-align:top;color:", function (props) {
  return props.copied ? _styles.color.positive : 'inherit';
}, ";");

var ClipboardIcon = function ClipboardIcon(props) {
  return /*#__PURE__*/_react["default"].createElement(StyledClipboard, props, function (copied) {
    return /*#__PURE__*/_react["default"].createElement(StyledIcon, {
      icon: copied ? 'check' : 'copy',
      copied: copied
    });
  });
};

exports.ClipboardIcon = ClipboardIcon;